import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { GraduationCap } from "lucide-react";
import { AdminLayout } from "@/components/AdminLayout";
import { api } from "@/lib/api";
import { TRAINING_SUMMARY } from "@/constants/testIds";

// Destino de la tarjeta "Invertido en capacitación" del Dashboard — resumen de TODA la
// empresa (una fila por registro, con el empleado ya resuelto), a diferencia de la pestaña
// Capacitación del expediente individual que solo muestra la de esa persona. Reutiliza el
// mismo patrón visual de tabla-con-encabezado que ya usa el Reporte Semanal de Asistencia
// en Registro de Jornada, en vez de construir un componente de tabla nuevo.
export default function TrainingSummary() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/trainings").then(({ data }) => setData(data));
  }, []);

  return (
    <AdminLayout>
      <div className="max-w-4xl" data-testid={TRAINING_SUMMARY.page}>
        <h1 className="font-heading text-3xl font-bold text-charcoal tracking-tight flex items-center gap-3">
          <GraduationCap className="w-7 h-7 text-terracotta" strokeWidth={1.5} /> Capacitación
        </h1>
        <p className="text-charcoal/60 mt-1">Todos los registros de capacitación de la empresa, un renglón por curso.</p>

        {data && (
          <div className="flex gap-6 mt-6">
            <div>
              <p className="text-xs text-charcoal/50">Invertido en total</p>
              <p data-testid={TRAINING_SUMMARY.totalCost} className="text-2xl font-heading font-bold text-charcoal">${(data.total_cost ?? 0).toLocaleString("es-MX")}</p>
            </div>
            <div>
              <p className="text-xs text-charcoal/50">Horas totales</p>
              <p data-testid={TRAINING_SUMMARY.totalHours} className="text-2xl font-heading font-bold text-charcoal">{(data.total_hours ?? 0).toLocaleString("es-MX")} h</p>
            </div>
          </div>
        )}

        <div className="mt-6 bg-card border border-petroleum/10 rounded-xl divide-y divide-petroleum/10">
          <div className="flex items-center p-3 text-xs font-semibold text-charcoal/50 uppercase tracking-wide">
            <span className="flex-1">Empleado</span>
            <span className="flex-1">Curso</span>
            <span className="w-24 text-right">Inversión</span>
            <span className="w-16 text-right">Horas</span>
            <span className="w-28 text-right">Fecha</span>
          </div>
          {data?.items.map((t) => (
            <Link
              key={t.id}
              to={`/admin/empleados/${t.employee_id}?tab=training`}
              data-testid={TRAINING_SUMMARY.row}
              className="flex items-center p-3 hover:bg-accent/50 transition-colors"
            >
              <span className="flex-1 text-sm font-medium text-charcoal">{t.employee_name}</span>
              <span className="flex-1 text-sm text-charcoal/80">
                {t.topic}
                {t.provider && <span className="text-charcoal/50"> · {t.provider}</span>}
              </span>
              <span className="w-24 text-right text-sm text-charcoal/80">${(t.cost ?? 0).toLocaleString("es-MX")}</span>
              <span className="w-16 text-right text-sm text-charcoal/80">{t.hours} h</span>
              <span className="w-28 text-right text-sm text-charcoal/50">{t.training_date}</span>
            </Link>
          ))}
          {data?.items.length === 0 && (
            <p data-testid={TRAINING_SUMMARY.emptyState} className="p-6 text-sm text-charcoal/50">Sin capacitaciones registradas todavía.</p>
          )}
        </div>
      </div>
    </AdminLayout>
  );
}
